import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#fff",
  "stroke-width": "6",
  d: "M2.879 37.879 37.591 3.166M3.121 2.879l34.713 34.712"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }